import React, {PropTypes} from 'react';
import {Link, browserHistory} from 'react-router';
import ConfirmDeleteComponent from '../components/confirm_box/confirm_box';
import CONSTANTS from '../common_constants';

export default class PackageInfo extends React.Component{
    constructor(props){
      super(props);
      this.state = {
        showConfirmBox : false
      }
    }
    toggleShowConfirmBox = (e) =>{
      if(e)
      {
        e.stopPropagation();
        e.preventDefault();
      }
      this.setState({
        showConfirmBox :  !this.state.showConfirmBox
      })
    }
    cancelAction = () =>{
      const {props} = this;
      let paramObj ={
          shipmentId : props.shipmentInfo.shipmentId,
          isShipper : props.shipmentInfo.isShipper
      }
      const self = this;
      const {userData} = this.props.authState;

      this.props.dashboardActions.cancelShimentBeforeHandOff(paramObj).then((data) => {

          if(props.isShipper){
            if(userData.email) amplitude.getInstance().setUserId(userData.email);
            amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.SHIPPER_CANCEL_SHIPMENT);
          }
          else if(!props.isShipper && !props.isReceiver){
            if(userData.email) amplitude.getInstance().setUserId(userData.email);
            amplitude.getInstance().logEvent(CONSTANTS.AMPLITUDE_EVENTS.CARRIER_CANCEL_SHIPMENT);
          }

          browserHistory.push('/dashboard');
        },(errorRes) => {
          if(errorRes.error === CONSTANTS.sessionInvalid){
            this.props.authActions.sessionValid(false);
            this.setState({isLoading: false})
            cookies.delete('_sd');
            return ;
          }
          this.setState({
            isLoading: false,
            error: errorRes.error
          })
        });
    }
    render(){
      const {props} = this;
      const {shipmentInfo} = props;
      const shipmentId = shipmentInfo.shipmentId ? shipmentInfo.shipmentId : props.shipmentId;
      shipmentInfo.imageUrl = shipmentInfo.imageUrl || '../../public/images/requester_flow/placeholder.png'

      let showCancelShipment = false;
      if(!shipmentInfo.isReceiver && shipmentInfo.shipmentStatus == 4)
        showCancelShipment = true ;


      return(
        <Link to = {'/shipment/' + shipmentId}>
          <ConfirmDeleteComponent
            onConfirmCallback = {this.cancelAction}
            closePopupCallback = {this.toggleShowConfirmBox}
            header = "Confirm"
            description = "Are you sure that you want to cancel the shipment?"
            popupState = {this.state.showConfirmBox}/>
          <div className = "shipment-package-info shipper-info cf">
            <div className = "shipper-info-left-content">
              <div className = "shipment-image" style = {{"backgroundImage": 'url("' + shipmentInfo.imageUrl + '")'}}></div>
              <div className = "shipment-content">
                <h2 className = "shipment-title">{shipmentInfo.title}</h2>
                <div className = "recipient-info"><span className = "to-seperator">To:&nbsp;</span>{shipmentInfo.recipient}</div>
              </div>
            </div>
            <div className = "shipper-info-right-content">
              <h2 className = "shipment-cost">{shipmentInfo.shipmentCost}</h2>
              <div className = "package-size">{shipmentInfo.packageSize}</div>
              {
                  showCancelShipment && <div onClick = {this.toggleShowConfirmBox}className = "cancel-shipment-section"> Cancel Shipment</div>
              }
            </div>
          </div>
      </Link>
      )
    }
}



// WEBPACK FOOTER //
// app/shipment/package_info.jsx